// Components==============
import React from 'react';
import './index.module.scss';
// =========================

export default function Shade({ onClick, color }) {
    return (
        <div
            style={{ background: color || null }}
            styleName="shader"
            onClick={onClick}
        />
    );
}
